import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../App/Hooks/reduxHooks'
import { setOpenEventDetails } from '../../store/calendarSlice'
import { IAppointment, TOpenEventDetails } from '../../types'
import { updateFormNavigationTabs } from '../Appointment/UpdateAppointment/settings/updateFormNavigationTabs'
import { IUpdateTabStructure } from '../Appointment/UpdateAppointment/types/ITabUpdateStructure'
import {
  ButtonNavigationIcons,
  ButtonNavigationTitle,
  ButtonNavigationWrapper,
  ButtonsNavigation,
  CrudButtonNavigationWrapper,
  CrudPanelCloseIcon,
  CrudPanelTitle,
  CrudPanelTitleWrapper,
} from '../sharedStyle'

interface IProps {
  openEventDetails: TOpenEventDetails
  openAppointment: IAppointment
  panelTitle: string | null
}

export const UpdateNavigation = ({
  openEventDetails,
  openAppointment,
  panelTitle,
}: IProps) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleFormSwitch = (tabValue: IUpdateTabStructure['value']) =>
    dispatch(
      setOpenEventDetails({
        openFormDetails: { type: tabValue, event: openAppointment },
      }),
    )

  const handlePanelClose = () =>
    dispatch(
      setOpenEventDetails({
        openFormDetails: { type: 'idle', event: null },
      }),
    )

  return (
    <div>
      <CrudPanelTitleWrapper>
        <CrudPanelTitle>{panelTitle}</CrudPanelTitle>
        <CrudPanelCloseIcon icon="xmark" onClick={handlePanelClose} />
      </CrudPanelTitleWrapper>
      <CrudButtonNavigationWrapper>
        {updateFormNavigationTabs.map(data => (
          <ButtonsNavigation
            active={openEventDetails.type === data.value}
            key={`${data.title}Form`}
            value={data.value}
            onClick={() => handleFormSwitch(data.value)}>
            <ButtonNavigationWrapper>
              <ButtonNavigationIcons icon={data.icon} />
              <ButtonNavigationTitle>
                {t(`${data.title}`)}
              </ButtonNavigationTitle>
            </ButtonNavigationWrapper>
          </ButtonsNavigation>
        ))}
      </CrudButtonNavigationWrapper>
    </div>
  )
}
